import { TZ_PLUS_HERO_DESKTOP_SRC, TZ_PLUS_HERO_MOBILE_SRC } from '../../config/tzPlus/assets';
import { TZ_PLUS_COPY } from '../../config/tzPlus/stops';

interface TzPlusHeroProps {
  /** The phone crop rather than the desktop one. */
  compact?: boolean;
}

/**
 * The upper band of both TZ+ welcome modals: a single image carrying the photograph, the Toronto Zoo
 * Plus lockup and the headline together.
 *
 * Sized by its own aspect ratio (`w-full`, no fixed height) rather than cropped to a set band. The
 * headline is part of the artwork, so any `object-cover` crop would cut words; letting the image
 * dictate its height cannot. Both modals have a bounded width, so the height is deterministic —
 * and on the phone card, which is `80vw` up to a cap, this is what lets the band track that width.
 */
const TzPlusHero = ({ compact = false }: TzPlusHeroProps) => (
  <img
    src={compact ? TZ_PLUS_HERO_MOBILE_SRC : TZ_PLUS_HERO_DESKTOP_SRC}
    // The words are inside the image, so they have to be spoken here or they are lost entirely.
    alt={compact ? TZ_PLUS_COPY.welcomeTitle : `${TZ_PLUS_COPY.welcomeTitle} ${TZ_PLUS_COPY.welcomeSubtitle}`}
    className="preflight preflight-img block h-auto w-full"
  />
);

export default TzPlusHero;
